import React, { useState } from 'react';

import CardLayout from '@magoosh/layouts/card';
import { paths } from 'config/path_helpers';
import fetch from 'utilities/fetch';

import TriangleExclamation from './assets/triangle_exclamation.svg';
import colors from '@magoosh/lib/styles/colors.module.scss';

interface Props {}

export default (props: Props) => {
  const [dismissed, setDismissed] = useState<boolean>(false);
  const [updatingCurriculum, setUpdatingCurriculum] = useState<boolean>(false);

  const dismiss = () => {
    setDismissed(true);

    fetch(paths.api.dismissBanner('sat_curriculum_update_dashboard_card'), {
      method: 'PUT'
    });
  };

  const switchCurriculum = () => {
    setUpdatingCurriculum(true);

    fetch(paths.api.userProfile(), {
      body: JSON.stringify({ userProfile: { examVersion: '2026_sat' } }),
      method: 'PUT'
    }).then(() => {
      window.location.reload();
    });
  };

  const linkStyle = updatingCurriculum
    ? { color: colors.grayLight, cursor: 'default', pointerEvents: 'none' as const }
    : { color: '#424FBC' };

  if (dismissed) {
    return (
      <CardLayout.Card className="align-items-center d-flex gap-s u-margin-T-m">
        <div className="flex-none">
          <img src={TriangleExclamation} alt="" />
        </div>

        <div className="text-gray-light u-margin-V-xxs">
          We won't show this again. You can switch your curriculum anytime from your account settings.
        </div>
      </CardLayout.Card>
    );
  } else {
    return (
      <CardLayout.Card borderGradient className="d-flex flex-column gap-m u-margin-T-m">
        <div className="align-items-center d-flex gap-s">
          <div className="flex-none">
            <img src={TriangleExclamation} alt="" />
          </div>

          <h3 className="u-margin-A-n">
            <strong>SAT Curriculum Update</strong>
          </h3>
        </div>

        <div className="d-flex flex-column gap-xs small">
          <div>
            We've updated our SAT curriculum to better match what you'll see on test day! The updated curriculum includes <strong>new lessons and guided practice</strong> for Math and Reading & Writing, giving you our most up-to-date SAT prep experience.
          </div>

          <div>
            We recommend <strong>trying</strong> the updated curriculum. If you're already well into your prep or your test is coming up soon, you may prefer to stay with your current curriculum for consistency. <strong>You can switch between the updated and current curriculum anytime in your Account Settings.</strong>
          </div>
        </div>
          
        <div className="d-flex flex-column flex-sm-row gap-xs">
          <a onClick={updatingCurriculum ? undefined : switchCurriculum} style={linkStyle}>
            <strong>Switch To Updated Curriculum</strong>
          </a>

          <div className="hidden-xs" style={{ color: '#424FBC' }}>|</div>

          <a onClick={updatingCurriculum ? undefined : dismiss} style={linkStyle}>
            <strong>Dismiss</strong>
          </a>
        </div>
      </CardLayout.Card>
    );
  }
};
